var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "f16-flight-up.22c885a1.png","uri@3x": __webpack_public_path__ + "f16-flight-up.0ebf7c45.png","uri@2x": __webpack_public_path__ + "f16-flight-up.e8ca36f0.png",
    width: 61,
    height: 368
});